import { errorFileLocalStore } from "../localStore/errorFileManage";
import { webSocketService } from "../services/WebSocketService";
import { useMessageStore } from "../store";
import {
  HeaderType,
  MessageSender,
  MessageStatus,
  MessageType,
  UploadFileInfo,
} from "../store/types";
import { getFileType } from "../utils/file";
import { removeObjectKeys } from "../utils/object";

export const useFileUpload = (
  fileInputRef?: React.RefObject<HTMLInputElement | null> | null,
) => {
  const { addOutgoingMessage, updateMessageStatus, setQuotedMsg, quotedMsg } =
    useMessageStore();

  const clearInputFile = () => {
    const inputElement = fileInputRef?.current;
    if (inputElement) {
      inputElement.value = "";
    }
  };

  const onError = (uid: string, fileInfo: UploadFileInfo) => {
    updateMessageStatus(uid, { status: MessageStatus.ERROR, fileInfo });
    errorFileLocalStore.set(fileInfo.fileId, fileInfo);
    clearInputFile();
  };

  const beforeUpload = (file: File, uid: string, fromRetry = false) => {
    const { name } = file;
    // 生成 Blob URL 用于预览
    const blobUrl = URL.createObjectURL(file);
    const fileType = getFileType(name);
    if (fromRetry) {
      updateMessageStatus(uid, { status: MessageStatus.Pending });
    } else {
      let quotedMsgData = {};
      if (quotedMsg) {
        quotedMsgData = {
          quoteMessageId: quotedMsg.id,
          quoteMessage: removeObjectKeys(quotedMsg, ["handleScrollToBottom"]),
        };
      }
      addOutgoingMessage({
        headerType: HeaderType.MESSAGE,
        clientId: uid,
        content: `{"fileName":"${name}", "fileUrl": "${blobUrl}", "fileId": "", "fileType": "${fileType}"}`,
        senderType: MessageSender.USER,
        type: fileType,
        timestamp: Date.now(),
        status: MessageStatus.Sending,
        ...quotedMsgData,
      });
      setQuotedMsg(undefined);
    }
    return true;
  };

  const onSuccess = (data: {
    fileId: string;
    filePath: string;
    sourceFileName: string;
  }) => {
    const fileType = getFileType(data.sourceFileName);
    // 通过WebSocket发送消息
    webSocketService.sendMessage(
      `{"fileName":"${data.sourceFileName}", "fileUrl": "${data.filePath}", "fileId": "${data.fileId}", "fileType": "${fileType}"}`,
      {
        msgType: fileType,
        noNeedInsertToMsgList: true,
        clientId: data.fileId,
      },
    );
    if (fileType === MessageType.File) {
      updateMessageStatus(data.fileId, {
        content: `{"fileName":"${data.sourceFileName}", "fileUrl": "${data.filePath}", "fileId": "${data.fileId}", "fileType": "${fileType}"}`,
      });
    }
    errorFileLocalStore.remove(data.fileId);
    clearInputFile();
  };

  return {
    onSuccess,
    beforeUpload,
    onError,
  };
};
